export default __webpack_public_path__ + "static/media/world.9dbb1b4a.svg";